module.exports = __webpack_public_path__ + "static/import5-min-cee8664a32cdba2f19c4a95663604f4e.png";